<template>
  <div>
    <el-card :gutter="24" v-if="activeName !='first'">
      <el-row :gutter="24">
          <el-alert v-if="activeName !='first'"
          title="统计信息"
          type="success"
          description="每天早上8时自动更新前一天数据."
          show-icon>
          </el-alert>
      </el-row>
        <el-row :gutter="24">
              <el-col :span="3">
              <el-input
                placeholder="id查询"
                v-model="params.id"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
               <el-col :span="3">
              <el-input
                placeholder="名称"
                v-model="params.name"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
        <el-col :span="3">
            <el-select
              v-model="params.type"
              placeholder="分享类型"
              size="mini"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="商品" value="0"></el-option>
              <el-option label="活动" value="1"></el-option>
              <el-option label="其他" value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="params.origin" placeholder="来源" size="mini">
              <el-option label="全部" value=""></el-option>
              <el-option label="其他" value="0"></el-option>
              <el-option label="商城" value="1"></el-option>
              <el-option label="多店铺" value="2"></el-option>
              <el-option label="怡康优选" value="3"></el-option>
            </el-select>
          </el-col>
            <el-col :span="7">
              <div class="block">
                <el-date-picker
                  size="mini"
                  v-model="params.times"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="search" size="mini"
                >搜索</el-button
              >
              <el-button type="primary" @click="exportData()" size="mini"
                >导出数据</el-button
              >
                <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="注意:最多只能导出开始和结束不超过一个月的数据!">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
            </el-col>
          </el-row>
    </el-card>
     <el-card v-else>
          <el-row :gutter="24">
            <!-- 部门列表弹窗 -start  -->
            <el-col :span="6">
              <el-button
                class="iconfont icon-sync-alt"
                @click="changeClick()"
                style="width: 100%"
                size="mini"
              >
                {{ corpName }}</el-button
              >
              <depTree
                :visible="visible"
                :data="checked"
                @onClose="handleClose"
                @change="handleChange"
              ></depTree>
            </el-col>
            <!-- 部门列表弹窗 -end  -->
            <el-col :span="3">
              <el-input
                placeholder="手机号"
                v-model="params.mobile"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="店铺id"
                v-model="params.distributor_id"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="商品id"
                v-model="params.item_id"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="货号"
                v-model="params.item_bn"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="活动id"
                v-model="params.active_id"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="3">
              <el-input
                placeholder="店铺名称"
                v-model="params.distributor_name"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="活动名称"
                v-model="params.active_name"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="商品名称"
                v-model="params.title"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-select
                v-model="params.type"
                placeholder="分享类型"
                size="mini"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="商品" value="0"></el-option>
                <el-option label="活动" value="1"></el-option>
                <el-option label="其他" value="2"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="params.origin" placeholder="来源" size="mini">
                <el-option label="全部" value=""></el-option>
                <el-option label="其他" value="0"></el-option>
                <el-option label="商城" value="1"></el-option>
                <el-option label="多店铺" value="2"></el-option>
                <el-option label="怡康优选" value="3"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="用户id"
                v-model="params.user_id"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                placeholder="转发人名称"
                v-model="params.realname"
                style="width: 100%"
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="7">
              <div class="block">
                <el-date-picker
                  size="mini"
                  v-model="params.times"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
              <el-button type="primary" @click="exportData()" size="mini">导出数据</el-button>
              <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="注意:最多只能导出开始和结束不超过一个月的数据!">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
            </el-col>
          </el-row>
        </el-card>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="分享列表" name="first">
        <el-table :data="catesList" :height="wheight - 130" v-loading="loading">
          <el-table-column prop="id" label="ID">
          </el-table-column>
          <el-table-column prop="item_id" label="商品id"> </el-table-column>
          <el-table-column prop="title" label="商品名称"> </el-table-column>
          <el-table-column prop="title" label="部门*店铺">
            <template slot-scope="scope">
              <p>
                {{ scope.row.department_name }}
                <span v-if="scope.row.distributor_id"
                  >(
                  <el-tag size="mini" effect="plain" type="success">{{
                    scope.row.distributor_name
                  }}</el-tag
                  >)</span
                >
              </p>
              <p>部门id: {{ scope.row.department_id }}</p>
              <p v-if="scope.row.distributor_id">
                店铺id: {{ scope.row.distributor_id }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="realname" label="转发人名称">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>链接: {{ scope.row.url }}</p>
                <p v-if="scope.row.item_bn">货号: {{ scope.row.item_bn }}</p>
                <p v-if="scope.row.active_id">
                  活动id: {{ scope.row.active_id }}
                </p>
                <p v-if="scope.row.active_name">
                  活动: {{ scope.row.active_name }}
                </p>
                <div slot="reference" class="name-wrapper">
                  <el-button type="text">{{ scope.row.realname }}</el-button>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="分享类型">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="success"
                v-if="scope.row.type == '0'"
                >商品</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '1'"
                >活动</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '2'"
                >其他</el-tag
              >
            </template>
          </el-table-column>
           <el-table-column prop="origin" label="来源" align="center">
          <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="default"
                v-if="scope.row.origin == '0'"
                >其他</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.origin == '1'"
                >商城</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                type="danger"
                v-else-if="scope.row.origin == '2'"
                >多店铺</el-tag
              >
              <el-tag size="mini" effect="plain" type="warning" v-else
                >怡康优选</el-tag
              >
            </template>
             </el-table-column>
          <el-table-column prop="create_time" label="更新时间" align="center">
            <template slot-scope="scope">{{
              scope.row.create_time | datetime("yyyy-MM-dd hh:mm:ss")
            }}</template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="分享次数统计" name="times">
        <el-table :data="dataList1" style="width: 100%">
          <el-table-column prop="origin_0" label="其他"> </el-table-column>
          <el-table-column prop="origin_1" label="商城"> </el-table-column>
          <el-table-column prop="origin_2" label="多店铺"> </el-table-column>
          <el-table-column prop="origin_3" label="怡康优选"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="用户分享次数统计" name="user">
        <el-table :data="dataList2" style="width: 100%">
          <el-table-column prop="user_id" label="成员id"> </el-table-column>
           <el-table-column label="来源">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="default"
                v-if="scope.row.origin == '0'"
                >其他</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.origin == '1'"
                >商城</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                type="danger"
                v-else-if="scope.row.origin == '2'"
                >多店铺</el-tag
              >
              <el-tag size="mini" effect="plain" type="warning" v-else
                >怡康优选</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="type" label="分享类型">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="success"
                v-if="scope.row.type == '0'"
                >商品</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '1'"
                >活动</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '2'"
                >其他</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="total" label="总数"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="商品分享次数统计" name="item">
        <el-table :data="dataList3" style="width: 100%">
          <el-table-column prop="item_id" label="商品id"> </el-table-column>
          <el-table-column prop="type" label="分享类型">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="success"
                v-if="scope.row.type == '0'"
                >商品</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '1'"
                >活动</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '2'"
                >其他</el-tag
              >
            </template>
          </el-table-column>
            <el-table-column label="来源">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="default"
                v-if="scope.row.origin == '0'"
                >其他</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.origin == '1'"
                >商城</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                type="danger"
                v-else-if="scope.row.origin == '2'"
                >多店铺</el-tag
              >
              <el-tag size="mini" effect="plain" type="warning" v-else
                >怡康优选</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="total" label="总数"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="部门分享次数统计" name="department">
        <el-table :data="dataList4" style="width: 100%">
          <el-table-column prop="department_id" label="部门id">
          </el-table-column>
          <el-table-column prop="type" label="分享类型">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="success"
                v-if="scope.row.type == '0'"
                >商品</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '1'"
                >活动</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '2'"
                >其他</el-tag
              >
            </template>
          </el-table-column>
           <el-table-column label="来源">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="default"
                v-if="scope.row.origin == '0'"
                >其他</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.origin == '1'"
                >商城</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                type="danger"
                v-else-if="scope.row.origin == '2'"
                >多店铺</el-tag
              >
              <el-tag size="mini" effect="plain" type="warning" v-else
                >怡康优选</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="total" label="总数"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-tab-pane>
    <el-tab-pane label="活动专题分享次数统计" name="active">
        <el-table :data="dataList5" style="width: 100%">
          <el-table-column prop="active_id" label="活动id">
          </el-table-column>
          <el-table-column prop="type" label="分享类型">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="success"
                v-if="scope.row.type == '0'"
                >商品</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '1'"
                >活动</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.type == '2'"
                >其他</el-tag
              >
            </template>
          </el-table-column>
           <el-table-column label="来源">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="plain"
                type="default"
                v-if="scope.row.origin == '0'"
                >其他</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                v-else-if="scope.row.origin == '1'"
                >商城</el-tag
              >
              <el-tag
                size="mini"
                effect="plain"
                type="danger"
                v-else-if="scope.row.origin == '2'"
                >多店铺</el-tag
              >
              <el-tag size="mini" effect="plain" type="warning" v-else
                >怡康优选</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="total" label="总数"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template><script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
import depTree from "./depTree";
import {
  getShareLog,
  getShareSync,
  getShareDataList,
  getShareExport
} from "../../../api/workwx";
export default {
  components: {
    depTree,
  },
  data() {
    return {
      activeName: "first",
      total_count: 0,
      params: {
        page: 1,
        pageSize: 20,
        times: [],
      },
      deplist: [],
      catesList: [],
      dataList1: [],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      dataList5: [],
      loading: false,
      visible: false,
      checked: {},
      corpName: "点击切换部门",
      memberTagDialog: false,
      corp_id: null,
      cropname: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      if(this.activeName == 'first'){
        this.getDataList();
      }else{
         this.getShareData(this.activeName);
      }
    },

    changeClick() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    handleResetClick() {
      this.$emit("change", {});
    },
    handleClick(tab, event) {
      this.params.page = 1;
      switch (tab.name) {
        case "first":
          this.getDataList();
          break;
        case "times":
          this.getShareData("times");
          break;
        case "user":
          this.getShareData("user");
          break;
        case "item":
          this.getShareData("item");
        case "department":
          this.getShareData("department");
          break;
        case "active":
          this.getShareData("active");
          break;
      }
    },
    search(){
       this.params.page = 1;
       this.getShareData(this.activeName);
    },
    getShareData(origin) {
      this.loading = true;
      getShareDataList({
        total_origin: origin,
        page: this.params.page,
        pageSize: this.params.pageSize,
        times:this.params.times,
        type:this.params.type,
        origin:this.params.origin,
        name:this.params.name,
        id:this.params.id
      }).then((response) => {
        this.total_count = response.data.data.total_count;
        this.loading = false;
        switch (origin) {
          case "times":
            this.dataList1 = response.data.data.list;
            break;
          case "user":
            this.dataList2 = response.data.data.list;
            break;
          case "item":
            this.dataList3 = response.data.data.list;
          case "department":
            this.dataList4 = response.data.data.list;
            break;
          case "active":
            this.dataList5 = response.data.data.list;
            break;
        }
      });
    },
    handleChange(arr) {
      this.params.department_id = arr.wx_department_id;
      this.params.corp_id = arr.corp_id;
      this.corpName = arr.name ? arr.name : arr.cropname;
      this.visible = false;
    },
    addTemplate() {
      // 添加商品
      if (this.params.corp_id == undefined || this.params.corp_id == null) {
        this.$message({
          type: "error",
          message: "请选择企业",
        });
      }
      getSnyEmployee({ corp_id: this.params.corp_id }).then((res) => {
        this.$message({
          type: "success",
          message: "同步成功",
        });
      });
    },

    getItems(data) {
      let items = [];
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    typesearch() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pageSize = pageSize;
      if(this.activeName == 'first'){
        this.getDataList();
      }else{
         this.getShareData(this.activeName);
      }
    },
    getDataList() {
      this.loading = true;
      getShareLog(this.params).then((response) => {
        this.catesList = response.data.data.list;
        this.total_count = response.data.data.total_count;
        this.loading = false;
      });
    },
    getShareSyncData() {
      this.loading = true;
      getShareSync().then((response) => {
        this.$message({
          type: "success",
          message: "同步成功",
        });
      });
    },
    exportData(){
        this.$notify({
              title: '成功',
              message: '正在导出,请稍后...',
              type: 'success'
            })
          this.params.total_origin=this.activeName;
          getShareExport(this.params).then(res=>{
              if(res.data.data.status){
                  this.$notify({
                    title: '成功',
                    message: '已加入队列!',
                    type: 'success'
                  })
                  var url=res.data.data.url
                  window.open(url)
              }else{
                this.$notify({
                    title: '失败',
                    message: res.data.data.msg,
                    type: 'error'
                  })
              }
          })
    }
  },

  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.store-picker {
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 3px;
  &:hover {
    background: #f5f7fa;
  }
  .store-info {
    padding-right: 20px;
  }
  .iconfont {
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// share.vue?5c52a346